export default __webpack_public_path__ + "static/media/FunFic.524c3d6b.png";